module.exports = __webpack_public_path__ + "static/media/clapperboard.1f5e2cf8.png";